import React, { useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";

import { request } from "../../../api";
import cancelPieceForm from "../cancel_piece_form";
import ImagePreview from "../../components/edit/ImagePreview";
import ImageDropzone from "../../components/edit/ImageDropzone";

const VtrgWasBecameImageForm = ({
  data,
  instanceType,
  instanceId,
  pieceType,
  slot,
  updatePiece,
  setActionLoading,
  ordn,
  afterUpdateVtrgPiece,
  getPieceForm,
}) => {
  const [successMsg, setSuccessMsg] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [disableBtns, setDisableBtns] = useState(false);
  const [values, setValues] = useState({
    was_became_type: data && data.was_became_type ? data.was_became_type : 0,
    was_image: data && data.was_image ? data.was_image : "",
    was_image_alt: data && data.was_image_alt ? data.was_image_alt : "",
    became_image: data && data.became_image ? data.became_image : "",
    became_image_alt:
      data && data.became_image_alt ? data.became_image_alt : "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue: setFormValue, // Используем setValue из react-hook-form
  } = useForm({
    defaultValues: {
      was_became_type: values.was_became_type,
      was_image: values.was_image,
      was_image_alt: values.was_image_alt,
      became_image: values.became_image,
      became_image_alt: values.became_image_alt,
      kind: pieceType,
      owner_type: instanceType,
      owner_id: instanceId,
    },
  });

  const isWideBlock = values.was_became_type === 3;
  const updatedTime =
    data && data.updated_at ? new Date(data.updated_at).getTime() : 0;

  const onSubmit = (localData, e) => {
    setDisableBtns(true);

    if (ordn) {
      setActionLoading(ordn);
    }

    // TODO костыль
    Object.keys(localData)
      .filter((key) => key in values)
      .forEach((key) => (localData[key] = values[key]));
    //
    const dataForm = new FormData();

    Object.entries(values).forEach(([key, value]) => {
      if (
        (["was_image", "became_image"].includes(key) && value instanceof File) ||
        !["was_image", "became_image"].includes(key)
      ) {
        dataForm.set(key, value);
      }
    });

    dataForm.append("kind", pieceType);
    dataForm.append("owner_type", instanceType);
    dataForm.append("owner_id", instanceId);

    // Проверка и копирование файла из was_image в became_image
    if (isWideBlock) {
      // Заменяем became_image на was_image, если became_image не задан
      console.log("isWideBlock", isWideBlock);
      const wasImage = dataForm.get("was_image");

      if (wasImage instanceof File) {
        dataForm.set("became_image", wasImage);
      }
    }

    if (data && data.id) {
      dataForm.append("id", data.id);
    }

    axios
      .post(`${request}/vitrage/pieces/${slot ? slot : "new"}`, dataForm, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
        if (response.statusText === "OK") {
          setSuccessMsg("Изменения успешно внесены");

          if (!slot && response.data.content) {
            getPieceForm(null);
            afterUpdateVtrgPiece(response.data.content);
          } else {
            afterUpdateVtrgPiece(
              response?.data?.data?.content
                ? response.data.data.content
                : localData
            );
          }
        } else {
          setErrorMsg("Произошли ошибки, пожалуйста попробуйте позже.");
        }
      })
      .catch((error) => {
        setErrorMsg("Произошли ошибки, пожалуйста попробуйте позже.");
      })
      .finally(() => {
        setDisableBtns(false);
        setTimeout(() => {
          setSuccessMsg(null);
          setErrorMsg(null);
          updatePiece(null);
          setActionLoading(null);
        }, 500);
      });
  };

  const onError = (errors, e) => {
    setErrorMsg("Произошла ошибка");
  };

  const handleTypeChange = (e) => {
    const newType = parseInt(e.target.value);
    setValues((prev) => ({
      ...prev,
      was_became_type: newType,
    }));
    setFormValue("was_became_type", newType); // Синхронизируем с react-hook-form
  };

  return (
    <div className="vtrg-edit-body">
      <h3>блок было-стало:</h3>
      <form
        onSubmit={handleSubmit(onSubmit)}
        noValidate="novalidate"
        className="formtastic vitrage_pieces_vtrg_centered_image"
        method="post"
      >
        <fieldset className="inputs">
          <select
            name="vitrage_pieces_vtrg_was_became_image[was_became_type]"
            {...register("was_became_type")}
            onChange={handleTypeChange}
            defaultValue={
              values && values.was_became_type ? values.was_became_type : 0
            }
          >
            <option value="0">Переключатель</option>
            <option value="1">Свайпер</option>
            <option value="2">Слайдер по скролу</option>
            <option value="3">Широкое изображение</option>
          </select>
        </fieldset>

        <fieldset className="inputs">
          <label>{`${isWideBlock ? "Изображение" : "Изображение было*"}`}</label>
          <ImageDropzone
            name="was_image"
            onChange={(files) => {
              const file = files[0];
              setValues((prev) => ({
                ...prev,
                was_image: file,
              }));
              setFormValue("was_image", file);
            }}
          />
          <ImagePreview
            image={values.was_image}
            version={updatedTime}
            alt={values.was_image_alt || "Изображение было"}
          />
        </fieldset>

        <fieldset className="inputs">
          <label>{`${isWideBlock ? "Альтернативная подпись" : "Альтернативная подпись было"}`}</label>
          <input
            type="text"
            name="vitrage_pieces_vtrg_was_became_image[was_image_alt]"
            {...register("was_image_alt", { value: values.was_image_alt })}
            onChange={(e) => {
              const text = e.target.value;
              setValues((prev) => ({
                ...prev,
                was_image_alt: text,
              }));
              setFormValue("was_image_alt", text);
            }}
            defaultValue={values?.was_image_alt ? values.was_image_alt : ""}
          />
          <p className="inline-hints"></p>
        </fieldset>

        {!isWideBlock && (
          <>
            <fieldset className="inputs">
              <label>Изображение стало*</label>
              <ImageDropzone
                name="became_image"
                onChange={(files) => {
                  const file = files[0];
                  setValues((prev) => ({
                    ...prev,
                    became_image: file,
                  }));
                  setFormValue("became_image", file);
                }}
              />
              <ImagePreview
                image={values.became_image}
                version={updatedTime}
                alt={values.became_image_alt || "Изображение стало"}
              />
            </fieldset>

            <fieldset className="inputs">
              <label>Альтернативная подпись стало</label>
              <input
                type="text"
                name="vitrage_pieces_vtrg_was_became_image[became_image_alt]"
                {...register("became_image_alt")}
                onChange={(e) => {
                  const text = e.target.value;
                  setValues((prev) => ({
                    ...prev,
                    became_image_alt: text,
                  }));
                  setFormValue("became_image_alt", text);
                }}
                defaultValue={values.became_image_alt}
              />
              <p className="inline-hints"></p>
            </fieldset>
          </>
        )}

        <input
          type="hidden"
          name="kind"
          value={pieceType}
          {...register("kind", { value: pieceType })}
        />
        <input
          type="hidden"
          name="owner_type"
          value={instanceType}
          {...register("owner_type", { value: instanceType })}
        />
        <input
          type="hidden"
          name="owner_id"
          value={instanceId}
          {...register("owner_id", { value: instanceId })}
        />
        <fieldset className="actions">
          <input type="submit" disabled={disableBtns} />
          <input
            type="reset"
            value="Отмена"
            onClick={() =>
              cancelPieceForm({ slot, updatePiece, afterUpdateVtrgPiece, getPieceForm })
            }
            disabled={disableBtns}
          />
        </fieldset>
      </form>
    </div>
  );
};

export default VtrgWasBecameImageForm;
